<template>
  <div class="wrapped">
    <b-skeleton size="is-large" height="110px" :active="!isLoaded"></b-skeleton>
    <div class="row" v-if="isLoaded">

      <div class="col-md-2 pl-0 pt-0 pb-0 ">
        <image-elm :elm="articleInfo" />

      </div>
      <div class="col-md-4 p-4">
        <p>{{ codart }}</p>
        <p class="descrizione">{{ descrizione }}</p>
      </div>
      <div class="col-md-2 p-4">
        <p>{{trans.get('b2b.article.quantity')}} ({{ unitamisura }})</p>
        <p>{{ quantita }}</p>
      </div>
      <div class="col-md-2 p-4">
        <p>{{trans.get('b2b.cart.total')}}</p>
        <p v-if="totale">{{ totale.toLocaleString('it-IT', {minimumFractionDigits: 3}) }} €</p>
      </div>
      <div class="col-md-2 p-4">

      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "doc-card",
  props: [
    'codart',
    'descrizione',
    'quantita',
    'totale',
    'unitamisura',
    'prezzo',
    'chiave'
  ],
  data() {
    return {
      articleInfo: null,
      isLoaded: false,
    }
  },
  mounted() {
    this.getArticleInfo(this.codart)
  },
  methods: {
    getPathImg: function () {
       if (this.articleInfo !== null){
        return this.articleInfo.cod_macrofamiglia + '-' +
            this.articleInfo.cod_famiglia + '-' +
            this.articleInfo.cod_categoria + '-' +
            this.articleInfo.cod_colore + '.jpg'
       }

    },
    getArticleInfo: function (codart) {
      axios({
        method: 'get',
        url: window.location.origin + '/data/getArticleInfo',
        params: {
          codart: codart
        }
      }).then(res => {
        if (res.data.data) {

          this.articleInfo = res.data.data
        }


        this.isLoaded = true
        this.$emit('loaded', this.chiave)

      }).catch(err => {
        console.log(err.response.data.message)
        this.isLoaded = true
        this.$emit('loaded', this.chiave)
      })
    },
  },
}
</script>

<style lang="scss" scoped>

.wrapped {
  width: 100%;
  padding: 0 5px;
  .row {

    height: 110px;
    background-color: #F5F5F5;

    .descrizione {
      text-transform: lowercase;

      &:first-letter {
        text-transform: uppercase;
      }
    }
  }
}
</style>
